module.exports = __webpack_public_path__ + "img/speaker-profile-element1.04295ab1.png";